import { Alert, Button, Card, Center, Group, Stack, Text, Title } from "@mantine/core";
import { IconAlertTriangle, IconBrandGoogle } from "@tabler/icons-react";
import { env } from "@/config/env";
import { EnvBadge } from "@/components/EnvBanner";
import { useAuth } from "./useAuth";

export function SignInScreen() {
  const { signIn, error } = useAuth();
  return (
    <Center mih="100vh" p="md">
      <Card withBorder shadow="sm" radius="md" w={420} p="xl">
        <Stack gap="lg">
          <Stack gap={4}>
            <Group justify="space-between">
              <Title order={3}>Elios Backoffice</Title>
              <EnvBadge />
            </Group>
            <Text c="dimmed" size="sm">
              Internal operator console. Sign in with your Elios Workspace account.
            </Text>
          </Stack>

          {error ? (
            <Alert color="red" variant="light" icon={<IconAlertTriangle size={16} />}>
              {error}
            </Alert>
          ) : null}

          <Button
            leftSection={<IconBrandGoogle size={18} />}
            onClick={() => void signIn()}
            size="md"
            fullWidth
          >
            Sign in with Google
          </Button>

          <Text c="dimmed" size="xs" ta="center">
            {env.allowedHostedDomain
              ? `Restricted to @${env.allowedHostedDomain} accounts.`
              : "Access is gated on the admin role; the backend re-enforces every action."}
          </Text>
        </Stack>
      </Card>
    </Center>
  );
}
